import { render, staticRenderFns } from "./Perstion.vue?vue&type=template&id=6490bb84&scoped=true"
import script from "./Perstion.vue?vue&type=script&lang=js"
export * from "./Perstion.vue?vue&type=script&lang=js"
import style0 from "./Perstion.vue?vue&type=style&index=0&id=6490bb84&prod&scoped=true&lang=css"
import style1 from "./Perstion.vue?vue&type=style&index=1&id=6490bb84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6490bb84",
  null
  
)

export default component.exports